import {
  Component,
  EventEmitter,
  inject,
  Inject,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { BrandingComponent } from './branding.component';
import { NgIf } from '@angular/common';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { RouterModule } from '@angular/router';
import { AuthState } from 'src/app/core/models/auth.model';
import { SignalStore } from 'src/app/shared/functions/store.functions';
import { AuthService } from 'src/app/core/services/auth.service';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [BrandingComponent, NgIf, TablerIconsModule, MaterialModule, RouterModule],
  templateUrl: './sidebar.component.html',
})
export class SidebarComponent implements OnInit {
  constructor(@Inject('auth-store') private readonly authStore = inject(SignalStore<AuthState>), private authService: AuthService) {}
  @Input() showToggle = true;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();
  user=null
  userLoaded = false;
  ngOnInit(): void {
    this.authService.userLoaded$.subscribe(loaded => {
      this.user = this.authStore?.selectKey("user")()?.username
      this.userLoaded = loaded;
    });
  }



  logout(){
    this.authService.logout()
  }

}